import {
  DOCUMENT_CONTROL_PANEL_HEIGHT,
  DOCUMENT_MAX_THUMBNAIL_WIDTH,
  DOCUMENT_VIEW_MIN_WIDTH,
  DOCUMENT_THUMBNAIL_BORDER_OFFSET_PX,
} from 'constants/documents';
import { checkIsLightTheme } from 'utils/theme';

export const getStyles = (
  theme,
  { thumbnailsWidth, contentWidth, fieldsWidth, additionalHeaderHeight } = {},
) => {
  const isLightTheme = checkIsLightTheme(theme.palette.type);

  return {
    documentViewWrapper: {
      backgroundColor: isLightTheme ? theme.palette.grey[50] : null,
    },
    documentSlideContainer: {
      maxWidth: `${thumbnailsWidth}px`,
      paddingBottom: '30px',
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    documentSlide: {
      flexShrink: 0,
      height: 0,
      minHeight: `calc(100% - ${DOCUMENT_CONTROL_PANEL_HEIGHT}px)`,
      minWidth: `${thumbnailsWidth}px`,
      padding: '10px 0 30px',

      '& > *': {
        marginBottom: '5px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        width: `${thumbnailsWidth}px`,
      },
    },
    documentViewContainer: {
      maxWidth: contentWidth ? `${contentWidth - thumbnailsWidth - fieldsWidth}px` : 'none',
      minWidth: `${DOCUMENT_VIEW_MIN_WIDTH}px`,
      paddingBottom: '30px',
      overflow: 'hidden',
    },
    documentView: {
      backgroundColor: isLightTheme ? theme.palette.grey['400'] : theme.palette.grey['700'],
      flex: 1,
      maxHeight: `calc(100% - ${DOCUMENT_CONTROL_PANEL_HEIGHT}px - ${
        additionalHeaderHeight || 0
      }px)`,
      padding: '10px 30px',

      '& > *': {
        marginBottom: '5px',
        display: 'inline-flex',
        justifyContent: 'center',
      },
    },
    pageNumber: {
      position: 'absolute',
      bottom: -20,
      left: 'calc((100% - 25px) / 2)',
      zIndex: 2,
      width: 25,
      height: 25,
      textAlign: 'center',
      fontSize: 16,
    },
    pageNumberState: {
      color: theme.palette.secondary.main,
    },
    thumbnailCard: {
      position: 'relative',
      marginBottom: '25px',
      '&:hover .document-thumbnail-overlay-container': {
        visibility: 'visible',
        opacity: 1,
        zIndex: 1,
      },
    },
    thumbnailOverlay: {
      position: 'absolute',
      bottom: 8,
      left: 31,
      right: -31,
      width: DOCUMENT_MAX_THUMBNAIL_WIDTH - DOCUMENT_THUMBNAIL_BORDER_OFFSET_PX,
      height: '60px',
      background: `linear-gradient(transparent, ${theme.palette.background.paper})`,
      visibility: 'hidden',
      opacity: 0,
      zIndex: -1,
      transition: 'visibility 0.15s, opacity 0.15s',
    },
    overlayDeleteButton: {
      '& > *': {
        pointerEvents: 'none',
      },
    },
  };
};
